<template lang="html">
  <div>
    <v-jumbotron
      class="text-xs-center text-sm-left mt-5"
      height="100%"
    >
      <v-container fill-height>
        <v-layout align-center row wrap>
          <v-flex v-if="urlQuery.firstName">
            <h3 class="display-3">Thanks {{urlQuery.firstName}}!</h3>
            <span class="subheading">We appreciate you taking the time to fill out this pre-meeeting survey and we're excited at this opportunity to bring solar to {{urlQuery.company}}!</span>
            <v-divider class="my-3"></v-divider>
            <div class="title mb-3">If you'd like to learn more about SunPeak or solar in general, visit our site</div>
            <a href="https://www.sunpeakpower.com">
              <v-btn
                slot="activator"
                class="mx-0"
                color="primary"
                large
                round
              >
                Learn More!
              </v-btn>
            </a>
          </v-flex>
          <v-flex v-else>
            <h3 class="display-3">Nothing to see yet</h3>
            <span class="subheading">We're working on this part of the site and hope to get it up and running soon!</span>
            <v-divider class="my-3"></v-divider>
            <div class="title mb-3">In the mean time, fill out some forms!</div>
            <v-btn
              slot="activator"
              class="mx-0"
              color="primary"
              large
              router
              to="/"
              round
            >
              Take Me Back
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-jumbotron>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  computed: {
    urlQuery: function () {
      let data = this.$route.query
      let company = data.company || 'your company'
      data.company = company
      return data
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/pages/Responses.vue